import { Control } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { selectorUser } from '../../../../../../lib/selectorUser';
import { getProductAccess, isProductRule } from '../../../../../../utils/ipaAccess';
import { SetupIPAHeader } from '../../SetupIPA/elements/SetupIPAHeader';
import styles from '../SetupIPADadosDeConcorrencia.module.scss';
import { FormValues } from '../interfaces';
import CompetitorDaysInput from './CompetitorDaysInput';
import SuppliersCompetitorDaysInput from './SuppliersCompetitorDaysInput';

// O prazo escondido continua no formulário e vai na gravação com o valor lido do servidor.
const useVisibleDeadlines = () => {
  const user = useSelector(selectorUser);
  if (!isProductRule(user)) return { pricing: true, negotiation: true };

  const { clientHasPricing, clientHasNegotiation } = getProductAccess(user);
  return { pricing: clientHasPricing, negotiation: clientHasNegotiation };
};

export const PricePreferenceSection = ({ control }: { control: Control<FormValues> }) => {
  const visibleDeadlines = useVisibleDeadlines();

  return (
    <div className={styles['setup-ipa__price-preference-competitor']}>
      <SetupIPAHeader title="Preferências do preço concorrente" subtitle="Defina o período de tempo que deve ser considerado no uso do preço concorrente" />
      {visibleDeadlines.pricing && (
        <div className={styles['setup-ipa__price-preference-competitor__content']}>
          <h4>Total de dias do preço concorrente para precificação</h4>
          <p>Somente preços concorrentes que estiverem dentro do total de dias definido serão considerados no processo de precificação.</p>
          <CompetitorDaysInput control={control} />
        </div>
      )}
      {visibleDeadlines.negotiation && (
        <div className={styles['setup-ipa__price-preference-competitor__content']}>
          <h4>Total de dias do preço concorrente para negociação com fornecedores</h4>
          <p>Somente preços concorrentes que estiverem dentro do total de dias definido serão considerados no módulo de Negociação com fornecedores.</p>
          <SuppliersCompetitorDaysInput control={control} />
        </div>
      )}
    </div>
  );
};
